"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelType = exports.TransactionState = void 0;
/** Enum of state possible for an action */
var TransactionState;
(function (TransactionState) {
    TransactionState["PENDING"] = "pending";
    TransactionState["CONFIRMED"] = "confirmed";
})(TransactionState || (exports.TransactionState = TransactionState = {}));
/** Channel type */
var ChannelType;
(function (ChannelType) {
    ChannelType[ChannelType["UNKNOWN"] = 0] = "UNKNOWN";
    ChannelType[ChannelType["CLEAR"] = 1] = "CLEAR";
    ChannelType[ChannelType["ENCRYPTED"] = 2] = "ENCRYPTED";
})(ChannelType || (exports.ChannelType = ChannelType = {}));
//# sourceMappingURL=transaction-types.js.map